module.exports = __webpack_public_path__ + "static/media/beluga-tan-preparer-tube.83c02678.png";